const requestcardColumns = (dispatchStatus) => {
  const getUserName = (record) =>
    [record?.["user.firstName"], record?.["user.surname"]]
      .filter(Boolean)
      .join(" ");
  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    // {
    //   title: "User ID",
    //   dataIndex: "userId",
    //   width: "15%",
    // },
    {
      title: "Name",
      render: (_, record) => getUserName(record),
      width: "20%",
    },
    {
      title: "Email",
      render: (_, record) => record?.["user.email"] || "",
      width: "20%",
    },
    {
      title: "Address",
      render: (_, record) => {
        const address = [record?.address1, record?.address2, record?.address3]
          .filter(Boolean)
          .join(",\n");
        return <div style={{ whiteSpace: "pre-line" }}>{address}</div>;
      },
      width: "20%",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "15%",
    },
    {
      title: "Status",
      render: (_, record) => {
        const statusText =
          record?.status === "pending" && record?.dispatchCard
            ? "Dispatched"
            : record?.status || "";
        return statusText
          ? `${statusText.charAt(0).toUpperCase()}${statusText.slice(1)}`
          : "";
      },
      width: "15%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => {
        const isActive =
          record?.status === "pending" && record?.dispatchCard === false;

        return (
          <button
            style={{
              backgroundColor: isActive ? "green" : "gray",
              cursor: isActive ? "pointer" : "not-allowed",
              color: "white",
              padding: "4px 10px",
              border: "none",
              borderRadius: "4px",
              width: "auto",
              display: "inline-block",
            }}
            disabled={!isActive}
            onClick={() =>
              dispatchStatus({
                userId: record?.userId,
                quantity: record?.quantity,
                amount: record?.amount,
                dispatchCard: true,
                cardId: record?.id,
              })
            }
          >
            Dispatch
          </button>
        );
      },
      width: "15%",
    },
  ];
};

export default requestcardColumns;
